<!-- section template -->
<template>
  <div :class="[$style.orderReservationList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <template v-for="(item, $index) in containerItem.orders.items">
      <div v-if="item.type === 'cosmetic'" :key="$index" class="orderReservationList__list">
        <div class="orderReservationList__no d-flex justify-content-between flex-md-row flex-column">
          <!-- 訂單編號: #{{ containerItem.orderNo }} -->
          <div class="align-self-md-center d-flex align-items-center order-md-0 order-1">
            <i v-if="!$globalIsDingBeauty" class="fontello fontello-paw mr-2 text-primary orderReservationList__icon"></i>
            <i v-else class="fontello fontello-db-lipstick mr-2 text-primary orderReservationList__icon isStyleDingBeauty"></i>
            <span class="text-primary orderReservationList__name mr-3">{{ item.pet.name }}</span>
            <span v-if="$globalCategoryVisible" class="text-gray-2 fs-sm">{{ item.pet.categoryTitle }}|{{ item.pet.sizeTitle }}</span>
            <span v-if="item.status === 0" class="ml-2 text-gray-1">已取消</span>
          </div>
          <div class="d-flex align-items-center">
            <BaseStoreTagList :store-list="[item.param.store]" class="justify-content-md-center" />
            <BaseButton v-if="!item.parentId" class="isStylePrimary isTextUnderline" :href="goToGoogleCalendar(item)" target="_blank">
              <i class="far fa-calendar mr-1"></i>
              <span>加入行事曆</span>
            </BaseButton>
          </div>
        </div>
        <BaseList :data-list="orderBillingList(item)" class="px-md-4 px-2" type="order" />
      </div>
      <div v-if="item.type === 'goods'" :key="$index" class="orderReservationList__list">
        <div class="orderReservationList__no d-flex justify-content-between flex-md-row flex-column">
          <div class="align-self-md-center d-flex align-items-center order-md-0 order-1">
            <span class="text-primary orderReservationList__name mr-3">商品購買</span>
            <span v-if="item.status === 0" class="ml-2 text-gray-1">已取消</span>
          </div>
        </div>
        <BaseList :data-list="orderBillingList(item)" class="px-md-4 px-2" type="order" />
      </div>
    </template>
    <template v-if="containerItem.params[0]">
      <hr class="my-2" />
      <BaseList :data-list="orderBillingParamsList" class="px-md-4 px-2" type="order" />
    </template>
    <div>
      <div class="orderReservationList__hr"></div>
      <BaseList :data-list="orderBillingTotal" class="px-md-4 px-2" type="order" />
    </div>
    <!-- 發票 -->
    <div v-if="containerItem.invoice.InvoiceNumber != null" class="invoice-detail-wrapper">
      <p class="invoice-detail__title">發票資訊</p>
      <div class="invoice-detail__item">
        <p class="item-name">發票日期</p>
        <p class="item-value">{{ containerItem.invoice.CreateTime }}</p>
      </div>
      <div class="invoice-detail__item">
        <p class="item-name">發票號碼</p>
        <p class="item-value">{{ containerItem.invoice.InvoiceNumber }}</p>
      </div>
      <div class="invoice-detail__item">
        <p class="item-name">隨機碼</p>
        <p class="item-value">{{ containerItem.invoice.RandomNum }}</p>
      </div>
      <div class="invoice-detail__item">
        <p class="item-name">發票形式</p>
        <p class="item-value">{{ taxTypeMap[containerItem.invoice.taxType] }}</p>
      </div>
      <div v-if="containerItem.invoice.taxType === 'B2C'" class="invoice-detail__item">
        <p class="item-name" style="margin-bottom: 0">載具類型</p>
        <p class="item-value" style="margin-bottom: 0">{{ carrierTypeMap(containerItem.invoice.CarrierType) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import formatCurrency from '@utils/format-currency'
import formatPaymentMethod from '@utils/format-payment-method'
import { formatOrder } from '@utils/format-order'
import { authComputed, merchantComputed } from '@store/helpers'
import formatPrice from '@utils/format-price'
import { conditionList } from '@utils/is-condition'
import { orderAtmInfoList, orderIsCanPay, orderIsUseDeduct, orderVaccInfoList, orderIsPrepaidUnpaidAndDeduct, orderBillingReserveList, orderReserveParamsList } from '@utils/ipetbooking-order'

export default {
  components: {},
  props: {
    containerItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taxTypeMap: {
        B2C: '個人',
        B2B: '公司',
        DONATE: '捐贈發票',
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.containerItem.byOrderExtrafields || {}

      return !!Object.keys(orderExtrafields)[0]
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrder
    },
    isUseDeduct() {
      return orderIsUseDeduct({ ...this.containerItem })
    },
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.containerItem })
    },
    priceTotal() {
      const ordersListTotal = this.containerItem.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0)
      const paramsListTotal = this.containerItem.params.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.total
      }, 0)
      return ordersListTotal + paramsListTotal
    },
    orderBillingParamsList() {
      const paramsList = (typeList) => {
        return orderReserveParamsList({
          typeList,
          params: this.containerItem.params,
        })
      }
      const total = this.containerItem.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0)
      return conditionList([
        {
          title: '小計',
          text: `${formatPrice(total)}`,
          textClass: 'font-number',
        },
        ...paramsList(['+', '-', '%']),
      ])
    },

    orderBillingTotal() {
      const orderStatus = formatOrder(this.containerItem)
      return conditionList([
        {
          title: `<span class="text-${orderStatus.color} fw-semi-bold">付款金額</span><br><span class="text-gray-2 fs-2sm">${orderStatus.paidInfo}</span>`,
          text: `${formatPrice(this.priceTotal)}`,
          class: 'align-items-md-end align-items-center mt-2',
          textClass: `font-number fs-xl fw-semi-bold text-${orderStatus.infoColor}`,
        },
      ])
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.containerItem, unpaid: this.priceTotal })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.containerItem, unpaid: this.priceTotal })
    },
  },
  created() {
    if (this.$route.query.activeTab) {
      this.activeTab = this.$route.query.activeTab
    }
  },
  mounted(){
    console.log(this.containerItem)
  },
  methods: {
    carrierTypeMap(key) {
      const map = {
        0: '手機條碼',
        1: '自然人憑證條碼',
        2: 'ezPay 電子發票載具',
      }

      if (key == null) return '無（寄送電子發票至客戶 email）'
      else return map[key]
    },
    formatCurrency,
    formatPaymentMethod,
    orderIsCanPay,
    formatPrice,
    orderBillingList(item) {
      return orderBillingReserveList({
        type: 'order',
        ...item,
        isUnpaidAndDeduct: this.isUnpaidAndDeduct,
        formatOrder: formatOrder(item),
      })
    },
    goToGoogleCalendar(containerItem) {
      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
      const text = `[${this.currentMerchant.title}${containerItem.param.store.title}] ${containerItem.pet.name} - ${containerItem.param.title}` || ''
      const start = containerItem.startDate.replace(/-/g, '').replace(/:/g, '').replace(/\s/g, 'T')
      const end = containerItem.endDate.replace(/-/g, '').replace(/:/g, '').replace(/\s/g, 'T')
      const dates = `${start}/${end}`
      const details = containerItem.param.description || ''
      const location = containerItem.param.store.fullAddress
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`

      return `http://www.google.com/calendar/event?${query}`
    },
    goToMemberReservationItem(containerItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              orderId: containerItem.id,
            },
          })
        })
      }

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          },
        })
      }
    },
    goToMemberReservationItemChildren(containerItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              orderId: containerItem.parentId,
            },
            query: {
              activeTab: 'children',
            },
          })
        })
      }

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          },
        })
      }
    },
    openDialogContact(item) {
      this.$globalDialog('DialogContact', {
        storeList: [item.param.store],
      })
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.orderReservationList {
  padding: 1.875rem;
  border: 1px solid rgba($color-primary, 0.5);

  @include max-md {
    padding: 1rem;
  }

  :global {
    .invoice-detail-wrapper {
      border: 1px solid rgba(104, 117, 128, 0.3);
      padding: 16px 23px;
      margin-top: 24px;

      .invoice-detail__title {
        font-size: 20px;
        color: #687580;
        margin-bottom: 0.5rem;
      }

      .invoice-detail__item {
        display: flex;
        justify-content: space-between;

        p {
          margin-bottom: 0.5rem;
        }

        .item-name {
        }

        .item-value {
        }
      }
    }

    .orderReservationList {
      &__icon {
        font-size: 1.25rem;
        @include max-md {
          font-size: 1.125rem;
        }
        &.isStyleDingBeauty {
          font-size: 1.375rem;
        }
        @include max-md {
          font-size: 1.125rem;
        }
      }
      &__no {
        padding: 1rem;
        margin-bottom: 2rem;
        font-size: 0.875rem;
        background: rgba($color-blue, 0.3);
        // border: 1px solid $color-primary;
      }
      &__name {
        font-size: 1.125rem;
        @include max-md {
          font-size: 1rem;
        }
      }
      &__list {
        &:not(:last-child) {
          margin-bottom: 1.875rem;
        }
      }
      &__hr {
        @include hr_decoration();
      }
      &__detailBoxInner {
        padding: 1.5rem 1rem 0;
        display: flex;
        @include max-md {
          display: block;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }
      }
      &__btn {
        &:not(:last-child) {
          margin-right: 1rem;
        }
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .orderReservationList {
        &__no {
          background: rgba($color: #e3c192, $alpha: 0.1);
        }
      }
    }
  }
}
</style>
